import {Link, useLocation} from 'react-router-dom';
import {observer} from 'mobx-react-lite';
import {Auth} from 'aws-amplify';
import {useService} from '../../../infrastructure/service/service';
import {Box, Button} from '@mui/material';
import {ICredentials} from 'aws-amplify/lib/Common/types/types';

// @ts-ignore
import logo from '../../../assets/images/logo/logo-dark.png'
import '../../../assets/css/style.css';
import '../../../assets/css/pages/home.css';

const Home = (): JSX.Element => {
  const location = useLocation();
  const {userService} = useService();

  return (
    <Box className={'home-container'}>
      <img className={'home-logo'} src={logo} alt={'Zitles'}/>
      {
        userService.isLoggedIn()
          ? <Button disableElevation className={'zitles-button home-button'} component={Link} to="/dashboard">Explore Now</Button>
          : location.pathname !== '/login' &&
              <Button disableElevation className={'zitles-button home-button'} onClick={(): Promise<ICredentials> => Auth.federatedSignIn()}>Login</Button>
      }
    </Box>
  );
}

export default observer(Home);
